<template>
	<div
		v-if="blok.children?.length"
		:id="`popover-button-${blok.name.toLowerCase()}`"
		class="w-full flex items-center gap-1 text-sm uppercase text-current outline-none lg:hover:border-white"
		:class="{ 'cursor-default': cursorDefault }"
	>
		<span
			class="py-1 lg:pt-0 lg:hover:border-secondary lg:hover:border-b-2 lg:hover:pb-[13px] mb-[0] lg:pb-[15px] flex-grow text-left"
			:class="isActiveRoute ? 'router-link-exact-active nav-link-dropdown' : ''"
		>
			{{ blok.name }}
		</span>
		<ChevronDownIcon
			v-if="!open"
			class="hidden lg:block h-5 w-5 flex-none text-current relative lg:-mt-4"
			aria-hidden="true"
		/>
		<ChevronUpIcon
			v-if="open"
			class="hidden lg:block h-5 w-5 flex-none text-current relative lg:-mt-4"
			aria-hidden="true"
		/>
		<div
			class="lg:hidden w-1/4 flex justify-end"
			@click="$emit('navigateToMenu', { Children: blok.children })"
		>
			<ChevronRightIcon class="h-6 w-6" aria-hidden="true" />
		</div>
	</div>

	<NuxtLink
		v-else
		:to="getLink(blok.link)"
		class="nav-link py-1 lg:pt-0 lg:hover:border-secondary lg:hover:border-b-2 lg:hover:pb-[13px] mb-[0] lg:pb-[15px]"
		@click="$emit('closeMobileMenu')"
	>
		{{ blok.name }}
	</NuxtLink>
</template>

<script setup lang="ts">
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/20/solid";
import type { BlokMenuItem } from "~/types/storyblok/storyblok";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";

interface Props {
	blok: BlokMenuItem;
	open: boolean;
	getLink: (link: BlokMenuItem["link"]) => string;
	isActiveRoute: boolean;
	cursorDefault?: boolean;
}

defineProps<Props>();
defineEmits(["closeMobileMenu", "navigateToMenu"]);
</script>
